import { Components } from "@thisgorilla/primate-ds";
import { useState } from "react";
import styled from "styled-components";

import { API_CALLS } from "../../../../../../API/api_calls";
import { useAppSelector } from "../../../../../../redux";
import { LikesProps } from "../../../../../../redux/slices/likes/Likes";
import { UpvoteDownvote } from "../../../../../Common";
import {
  FlexColumn,
  FlexRow,
  FlexRowSpaced,
} from "../../../../../Common/Styles";
import { CreateRepost } from "../../CreateRepost";
import { usePostCardContext } from "../PostCardContent";
import PostComments from "./PostComments";
import { ReactionsButton } from "./Reactions";

export const Footer = () => {
  const [createRePostOpen, setCreateRePostOpen] = useState(false);
  const { postId, isOnExpandedPostView } = usePostCardContext();
  const [isCommentShow, setIsCommentShow] = useState(false);
  const { total_count } = useAppSelector(
    (state) => state.comments.allPostComments?.[postId]
  );
  const {
    processed_posts,
    dislikeAPost_API_STATUS,
    likeAPost_API_STATUS,
    removeLikeOrDislikeForAPost_API_STATUS,
  } = useAppSelector((state) => state.newsfeed);
  const {
    Likes,
    Dislikes,
    user_liked,
    EmbeddedPostRepostCount = 0,
  } = processed_posts[postId];

  const handleVote = (voteType: Omit<LikesProps.LikeType, "none">) => {
    if (likeAPost_API_STATUS === "progress") return;
    if (removeLikeOrDislikeForAPost_API_STATUS === "progress") return;
    if (dislikeAPost_API_STATUS === "progress") return;
    if (user_liked === voteType) {
      API_CALLS.POST_LIKES.removeLikeOrDislikeForAPost({
        post_id: postId,
      });
      return;
    }

    if (voteType === "liked")
      API_CALLS.POST_LIKES.likeAPost({ post_id: postId });
    if (voteType === "disliked")
      API_CALLS.POST_LIKES.dislikeAPost({ post_id: postId });
  };

  return (
    <FooterContainer $gapInPx={10}>
      <FlexRowSpaced>
        <UpvoteDownvote
          userVoted={user_liked !== "none"}
          upvoteCount={parseInt(`${Likes}`)}
          downvoteCount={parseInt(`${Dislikes}`)}
          downVoteHandler={() => handleVote("disliked")}
          upVoteHandler={() => handleVote("liked")}
        />
        <Components.Button
          iconPosition="left"
          iconType="MessageCircle"
          kind="Tertiary"
          color="Primary"
          size="Small"
          disabled={false}
          label={String(total_count)}
          onClick={() => {
            setIsCommentShow(!isCommentShow);
          }}
        />
        <ReactionsButton />
        <Components.Button
          iconPosition="left"
          iconType="Repeat"
          kind="Tertiary"
          color="Primary"
          size="Small"
          disabled={false}
          label={`${EmbeddedPostRepostCount}`}
          onClick={() => setCreateRePostOpen(true)}
        />
        <CreateRepost
          createRePostOpen={createRePostOpen}
          setCreateRePostOpen={setCreateRePostOpen}
        />
        <FlexRow $gapInPx={0}>
          <Components.IconButton
            disabled={false}
            iconType="Bookmark"
            kind="Tertiary"
            onClick={() => {}}
            size="Small"
          />
          <Components.IconButton
            disabled={false}
            iconType="Share"
            kind="Tertiary"
            onClick={() => {}}
            size="Small"
          />
        </FlexRow>
      </FlexRowSpaced>
      <PostComments
        isCommentShow={isCommentShow}
        post_id={postId}
        scrollAreaId={
          isOnExpandedPostView ? "expanded-post-card-right-container" : ""
        }
      />
    </FooterContainer>
  );
};

const FooterContainer = styled(FlexColumn)`
  padding: ${({ theme }) => theme.spacing["spacing-5"].value}rem
    ${({ theme }) => theme.spacing["spacing-3"].value}rem;
`;
